<template>
  <div class="container-fluid main">
    <div class="row header">
      <img src="../assets/logo.png"/>
    </div>
    <div class="body">
      <div class="card-body">
        <div class="title">保函真伪查询结果</div>
        <div class="row content">
          <div class="col-6">
            <div v-show="res" class="resBox">
              <img class="resImg" src="../assets/yes.png" />
              <p class="resMsg">查询成功</p>
            </div>
            <div v-show="!res" class="resBox">
              <img class="resImg" src="../assets/no.png" />
              <p class="resMsg">查询失败</p>
            </div>
          </div>
          <div class="col-6" style="padding: 0;">
            <div class="rightBox" v-if = "effective">
              <div class="row msg">
                <span class="col-4">保函编号：</span>
                <span class="info col-8">{{guaranteeNum}}</span>
              </div>
              <div class="row msg">
                <span class="col-4">申请单位名称：</span>
                <span class="info col-8">{{employer}}</span>
              </div>
              <div class="row msg">
                <span class="col-4">受益人名称：</span>
                <span class="info col-8">{{contractor}}</span>
              </div>
              <div class="row msg">
                <span class="col-4">工程名称：</span>
                <span class="info col-8">{{projectName}}</span>
              </div>
              <div class="row msg">
                <span class="col-4">担保金额(万元):</span>
                <span class="info col-8">{{guaranteeAmount == '' ? '暂无信息' : parseFloat(guaranteeAmount / 10000.0).toFixed(7)}}</span>
              </div>
              <div class="row msg" v-if="cutOffDateShow">
                <span class="col-4">担保截止日：</span>
                <span class="info col-8">{{cutOffDate}}</span>
              </div>
              <div class="row msg">
                <span class="col-4">担保人：</span>
                <span class="info col-8">{{guarantee}}</span>
              </div>
            </div>
            <div v-else style="margin-top: 100px;font-size: 20px;">
              该保函已到期失效，不再显示具体内容。
            </div>
          </div>
        </div>
        <div class="bottomBtn">
            <button type="button" class="btn btn-primary queryBtn" @click="goIndex">继续查询</button>
        </div>
      </div>
    </div>
<!--    <div class="row bottom">
      <div class="bottomText">晋ICP备2022005121号-1 &#12288;&#12288;&#12288;&#12288;山西嘉泰工程担保有限公司版权所有</div>
    </div> -->
  </div>
</template>

<script>
  export default {
    name: 'pcRes',
    data() {
      return {
        res: false,
        barcode: "",
        secCode: "",
        num: "",
        effective: null,
        guaranteeNum: "暂无信息",
        projectName: "暂无信息",
        employer: "暂无信息",
        contractor: "暂无信息",
        guarantee: "暂无信息",
        guaranteeAmount: "",
        cutOffDate: "暂无信息",
        cutOffDateShow: true,
      }
    },
    created() {
      this.barcode = this.$route.params.barCode;
      this.secCode = this.$route.params.secCode;
      this.num = this.$route.params.num;
      this.checkRes();
    },
    methods:{
      async checkRes() {
        const { data: res } = await this.$axios.get(
          this.$static.SERVER_URL + "/api/checkRes/getRes",
          {
            params: {
              barCode: this.barcode,
              secCode: this.secCode,
              num: this.num,
              type: "jt",
            }
          }
        );
        if (res.code == 200) {
          if((res.data == null || res.data == undefined || res.data == "") && res.msg == "保函已失效"){
            this.effective = false;
          } else {
            this.guaranteeNum = res.data.guaranteeNum;
            this.projectName = res.data.projectName;
            this.employer = res.data.employer;
            this.contractor = res.data.contractor;
            this.guarantee = res.data.guarantee;
            this.guaranteeAmount = res.data.guaranteeAmount;
            this.cutOffDate = res.data.cutOffDate;
            if(this.cutOffDate == null || this.cutOffDate == undefined || this.cutOffDate == ''){
              this.cutOffDateShow = false;
            } else {
              this.cutOffDateShow = true;
            }
            this.effective = true;
          }
          this.res = true;
        } else {
          this.res = false;
        }
      },
      goIndex() {
        this.$router.push({name: 'index'});
      }
    }
  }
</script>

<style scoped>
  .main {
    height: 624px;
    width: 1100px;
    background-image: url(src/assets/background.jpg);
    background-size: cover;
    font-family: "microsoft yahei";
  }

  .header {
    background-color: rgb(255, 255, 255, 0.5);
    height: 40px;
  }

  .header img {
     height: 100%;
     margin-left: 190px;
  }

  .bottom {
    background-color: white;
    opacity: 0.5;
    height: 30px;
    width: 100%;
    position: fixed;
    bottom: 0;
  }

  .bottomText {
    text-align: center;
    width: 100%;
    font-size: 10px;
    line-height: 30px;
  }

  .body {
    margin-top: 10%;
    height: 50%;
    width: 100%;
  }

  .card-body {
    height: 320px;
    margin-left: 180px;
    width: 750px;
    max-width: 1200px;
    background-color: rgba(255, 255, 255, 0.85);
    border-radius: 5px;
    padding: 10px;
  }

  .titleRow {
    text-align: center;
  }

  .title {
    font-size: 22px;
    font-weight: 800;
    color:#007BFF;
  }

  .content {
    height: 83%;
  }

  .leftBox {
    margin-top: 10%;
    height: 70%;
  }

  .seq {

    height: 100%;
    margin-top: 2%;
  }

  .rightBox {
    margin-top: 2%;
    height: 90%;
    text-align: left;
    border-left: 1px dashed #CCC;
    padding-left: 60px;
    font-size: 12px;
  }

  .msg {
    margin-top: 13px;
  }

  .queryBtn {
    width: 60px;
    height: 20px;
    font-size: 9px;
    padding: 0px;
    background-color: #0069d9;
    border-radius: 3px;
  }

  .resBox {
    margin-top: 20px;
    height: 90%;
  }

  .resImg {
    width: 150px;
    margin-bottom: 20px;
  }

  .resMsg {
    font-weight: 600;
    color: #007BFF;
    font-size: 24px;
  }

  .info {
    font-weight: 700;
  }

  .bottomBtn{
    text-align: right;
    margin-right: 10px;
  }

  .btn:focus,
  .btn:active:focus,
  .btn.active:focus,
  .btn.focus,
  .btn:active.focus,
  .btn.active.focus {
      outline: none !important;
      box-shadow:none !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/pcRes.vue